import { useEffect, useMemo, useState } from "react";
import moment from 'moment';
import { fetchAPI } from "../../utils/utils";
import { parseUTCWallClock } from "../../utils/utcWallClock";
import '../notifications/notifications.css';

function Event({ hasForm, socket, event, selectEvent, isSelected }) {
    const [assistencies, setAssistencies] = useState([]);

    useEffect(() => {
        if (event?.id) {
            fetchAPI(`/assistencies_event/${event.id}`, data => {
                setAssistencies(data.data)
            })
        }
    }, [event?.id]);

    useEffect(() => {
        if (isSelected && event) selectEvent(event);
    }, [isSelected]);

    const formattedDate = event && moment(event['data-esperada-inici'])
        .format('DD/MM HH:mm')

    const subgroupOptions = {
        'No confirmat': {
            color: 'orange',
            emoji: '😶'
        },
        'Vinc': {
            color: 'green',
            emoji: '✅'
        },
        'No vinc': {
            color: 'red',
            emoji: '❌'
        }
    }

    return (
        <div
            className={`choose-event-item ${isSelected ? 'active' : ''}`}
            onClick={() => event ? selectEvent(event) : selectEvent()}
        >
            <div><strong>{ hasForm ? '(📝) ' : '' }{event ? event.title : 'No triar cap esdeveniment'}</strong></div>
            { event && <div>{formattedDate}</div> }
            { event && <div style={{ display: 'flex', gap: 10 }}> {
                Object.keys(subgroupOptions).map(subgroupName =>
                    <span key={subgroupName} style={{ color: subgroupOptions[subgroupName].color }}>
                        {subgroupOptions[subgroupName].emoji}&nbsp;
                        {assistencies.filter(row => row.assistencia === subgroupName).length}
                    </span>)
                } </div>
            }
        </div>
    )
}

export const dateId = d => [d.getDate(), d.getMonth(), d.getFullYear()].join('-');

function ChooseEvent({ forms, showPast, setShowPast, socket, selectedEvent, setSelectedEvent, setSelectedDay, events, setEvents }) {
    const PAGE_SIZE = 10;
    const showPastEvents = () => setShowPast(true);
    const showFutureEvents = () => setShowPast(false);
    const [visibleFutureCount, setVisibleFutureCount] = useState(PAGE_SIZE);
    const [visiblePastCount, setVisiblePastCount] = useState(PAGE_SIZE);

    useEffect(() => {
        fetchAPI('/calendar', data => {
            setEvents(data.calendar_events.events);
        })
    }, []);

    useEffect(() => {
        setVisibleFutureCount(PAGE_SIZE);
        setVisiblePastCount(PAGE_SIZE);
    }, [events]);

    // Parsed once per list: sorting ~900 events parsing dates in the comparator froze every render.
    const datedEvents = useMemo(() => events.map(event => ({
        event,
        start: parseUTCWallClock(event['data-esperada-inici']).getTime(),
        end: parseUTCWallClock(event['data-esperada-fi']).getTime(),
    })), [events]);
    const now = Date.now();

    const sortedPastEvents = datedEvents
        .filter(({ start }) => start <= now)
        .sort((a, b) => b.start - a.start)
        .map(({ event }) => event);

    const sortedFutureEvents = datedEvents
        .filter(({ end }) => now <= end)
        .sort((a, b) => a.start - b.start)
        .map(({ event }) => event);

    useEffect(() => {
        if (!selectedEvent) return;

        const selectedPastIndex = sortedPastEvents.findIndex(event => event.id === selectedEvent);
        if (selectedPastIndex !== -1) {
            setVisiblePastCount(prev => {
                if (selectedPastIndex + 1 <= prev) return prev;
                return Math.ceil((selectedPastIndex + 1) / PAGE_SIZE) * PAGE_SIZE;
            });
            return;
        }

        const selectedFutureIndex = sortedFutureEvents.findIndex(event => event.id === selectedEvent);
        if (selectedFutureIndex !== -1) {
            setVisibleFutureCount(prev => {
                if (selectedFutureIndex + 1 <= prev) return prev;
                return Math.ceil((selectedFutureIndex + 1) / PAGE_SIZE) * PAGE_SIZE;
            });
        }
    }, [selectedEvent, sortedPastEvents, sortedFutureEvents]);

    const renderEvent = event => (
        <Event
            key={event.id}
            event={event}
            isSelected={selectedEvent === event.id}
            selectEvent={ev => {
                setSelectedEvent(ev.id);
                const dayId = dateId(new Date(ev['data-esperada-inici']))
                setSelectedDay(dayId);
            }}
            socket={socket}
            hasForm={!!forms && (event.id in forms)}
        />
    );

    const visiblePastEvents = sortedPastEvents.slice(0, visiblePastCount).map(renderEvent);
    const visibleFutureEvents = sortedFutureEvents.slice(0, visibleFutureCount).map(renderEvent);

    const shouldShowPastLoadMore = visiblePastCount < sortedPastEvents.length;
    const shouldShowFutureLoadMore = visibleFutureCount < sortedFutureEvents.length;

    return (
        <>
            <div className="choose-event-sidebar-header">
                <div className="selection-mode-tabs">
                    <button onClick={showPastEvents} className={`selection-mode-tab ${showPast ? 'active' : ''}`}>
                        Passats
                    </button>
                    <button onClick={showFutureEvents} className={`selection-mode-tab ${!showPast ? 'active' : ''}`}>
                        Futurs
                    </button>
                </div>
            </div>

            <div className="choose-event-scroll">
                { showPast && (
                    <div className="choose-event-list">
                        {visiblePastEvents}
                        { shouldShowPastLoadMore && (
                            <div className="choose-event-item" style={{ textAlign: 'center' }}>
                                <button
                                    onClick={() => setVisiblePastCount(prev => prev + PAGE_SIZE)}
                                >
                                    Carrega més esdeveniments
                                </button>
                            </div>
                        ) }
                    </div>
                ) }

                { !showPast && (
                    <div className="choose-event-list">
                        {visibleFutureEvents}
                        { shouldShowFutureLoadMore && (
                            <div className="choose-event-item" style={{ textAlign: 'center' }}>
                                <button
                                    onClick={() => setVisibleFutureCount(prev => prev + PAGE_SIZE)}
                                >
                                    Carrega més esdeveniments
                                </button>
                            </div>
                        ) }
                    </div>
                ) }
            </div>
        </>
    )
}

export default ChooseEvent;